import * as tslib_1 from "tslib";
import { INIT_DATA_STATE } from './state';
import { ActionTypes } from './actions';
export function dataReducer(state, action) {
    var _a;
    if (state === void 0) { state = INIT_DATA_STATE; }
    switch (action.type) {
        case ActionTypes.SIREN_RESPONSE: {
            return tslib_1.__assign({}, state, { responses: tslib_1.__assign({}, state.responses, (_a = {}, _a[action.payload.id] = action.payload.response, _a)) });
        }
        case ActionTypes.RESET_ALL_DATA: {
            return {
                responses: {}
            };
        }
        case ActionTypes.RESET_DATA: {
            return { responses: { 'rel/authenticationResult': state.responses['rel/authenticationResult'] } };
        }
        default: return state;
    }
}
